<template>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">

          <div class="logo-mitte">
            <div>Robin Jünkersfeld</div>
            <div class="d-flex justify-content-center">
              <span class="subtext">Editor</span>
              <span class="subtext">&nbsp;&amp;</span>
              <span class="subtext logo-active">&nbsp;Colorist</span>
            </div>
          </div>

        </div>
        <nav class="navbar">
          <div>
            <router-link to="/editing">Editing</router-link>
            <router-link to="/grading">Grading</router-link>
            <router-link to="/vita">Vita</router-link>
            <router-link to="/tools">Tools</router-link>
            <router-link to="/kontakt">Kontakt</router-link>
          </div>
        </nav>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Navbar',
  mounted() {
    //console.log(this.$route)

  },
  }

</script>